import {
  Button
} from '@mui/material';
import { useState } from 'react';
import { useRecordContext, useNotify } from 'react-admin';
import { RemoveCircleOutline, OpenWith, PendingActions } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { ClearMessage, showMerchantConfirmPasswordModal } from '../../../redux/creates-action/ConfirmPasswordAction';
import { useEffect } from 'react';
import Color from '../../layout/color/Color';
import FontSize from '../../layout/FontSize';


const closeSmallButton = {
  bgcolor: Color.Close,
  borderRadius: '30px',
  border: "1px solid #ccc",
  color: Color.Button,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

export default function CustomDeleteButton(props) {
  const record = useRecordContext(props);

  const [status, setStatus] = useState(record.status);
  const [message, setMessage] = useState('');

  const notify = useNotify();
  const dispatch = useDispatch();
  const data = useSelector(state => state.password.data);

  useEffect(() => {
    setStatus(record.status);
  }, [record.status]);

  useEffect(() => {
    if (data.notify !== '') {
      setMessage(data.notify);
      if (data.status !== 0) {
        setStatus(data.status);
      }
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.notify, data.status]);

  useEffect(() => {
    if (message !== '') {
      notify(message, { type: data.style });
      dispatch(ClearMessage());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  const handleOpen = () => {
    dispatch(showMerchantConfirmPasswordModal(`Are you sure to ${status === 1 ? "close": "open"} this SubMerchant?`, 'Please enter password to comfirm.', record, 'CLOSE_SUBMERCHANT'))
  };

  if (!record || record.id == null) {
    return null;
  };

  return (
    <>
      <Button
        size="small"
        onClick={handleOpen}
        startIcon={status === 1 ? <RemoveCircleOutline  /> : status === 3 ? <OpenWith  /> : <PendingActions  />}
        color={status === 3 ? "info" : "error"}
        disabled={status === 2 ? true : false}
        sx={closeSmallButton}
      >
        {status === 1 ? "Close" : status === 2 ? "InActive" : "Open"}
      </Button>
    </>
  );
}
